import ReactGA from 'react-ga';
import { action, observable } from 'mobx';


export default class TrackingStore {

    constructor(uaid) {
        if (!uaid) {
            //throw new Error('UA ID is required for tracking');
        }

        this.uaid = uaid;
        this.sessionStartTime = Date.now();
    }

    @observable history = [];

    @action click(action, meta) {
        this._event('Click', action, meta);
    }

    @action event(action, meta) {
        this._event('Event', action, meta);
    }

    @action impression(action, meta) {
        this._event('Impression', action, meta);
    }

    @action pageview(page, meta) {
        this.push(this._bundle('Pageview', page, meta));
        ReactGA.pageview(page);
    }

    @action push(elem) {
        if (elem) this.history.push(elem);
    }

    _bundle(category, action, meta) {
        const bundle = {
            action,
            category,
            value: Date.now() - this.sessionStartTime,
        };

        if (meta) {
            bundle.label = JSON.stringify(meta);
        }

        return bundle;
    }

    _event(category, action, meta) {
        const e = this._bundle(category, action, meta);

        this.push(e);
        ReactGA.event(e);
    }

}



// WEBPACK FOOTER //
// ./src/stores/TrackingStore.js